export default __webpack_public_path__ + "static/media/not-responding.f1b3d8c9.svg";